
<template lang="pug">
.flex.items-center

  //- 実績客数
  .q-mx-xs 実績客数：

  div(v-if="error")
    q-icon.app__icon(
      name="warning"
      color="warning"
    )
    q-tooltip.app__tooltip(
      anchor="bottom right"
      self="top right"
    )
      div(v-for="text of error") {{text}}
  div(v-if="resultSum") {{resultSum}} ／

  SelectRefDate.q-mx-sm(
    :disable="dailyStore == null"
    :value="$get(dailyStore, 'reference_date')"
    @change="onChangeReferenceDate"
  )

  //- 参考日の天気
  Weather.q-ml-sm(:data="weather")

  //- RE変更ボタン
  div
    q-btn(
      flat
      :disable="dailyStore == null"
      @click="reEdit"
    ) RE
    q-tooltip.app__tooltip(
      :disable="dailyStore == null"
      anchor="bottom right"
      self="top right"
    )
      table
        tr: <td>レーン</td>    <td>：</td><td>{{$get(dailyStore, 're1')}}</td>
        tr: <td>セミセルフ</td><td>：</td><td>{{$get(dailyStore, 're2')}}</td>
        tr: <td>カウンター</td><td>：</td><td>{{$get(dailyStore, 're3')}}</td>
        tr: <td>概算用</td>    <td>：</td><td>{{$get(dailyStore, 're4')}}</td>

  //- RE編集ポップアップ
  ShiftsEstimatesRe(
    ref="shifts_estimates_re"
    @confirm="reConfirm"
  )

</template>

<script>
import {isEmpty} from 'lodash-es'

// import {dateFilter} from 'helpers/date'

import AxiosMixin from 'mixins/axios'
import SelectRefDate from 'components/SelectRefDate'
import ShiftsEstimatesRe from 'views/ShiftsEstimatesRe'
import Weather from 'components/Weather'

export default {
  components: {SelectRefDate, Weather, ShiftsEstimatesRe},
  mixins: [AxiosMixin],

  props: {
    storeCode: {required: true},
    floorCode: {required: true},
    date:      String,
  },

  // props: {
  //   estimate:   {type: Array,  required: true},
  //   results:    {type: Array,  required: true},
  // },

  data() {
    return {
      dailyStore: null,

      weather: null,

      resultSum: 0,
      error: null,
    }
  },

  computed: {
    key() {
      return this.storeCode == null || this.floorCode == null || this.date == null ? null
        : this.storeCode + '/' + this.floorCode + '/' + this.date
    },
  },

  watch: {
    key() {
      this.refresh()   .catch(() => {console.warn('refresh reject in ShiftsEstimates watch key')})
    },
  },

  mounted() {
    this.refresh()   .catch(() => {console.warn('refresh reject in ShiftsEstimates mounted')})
  },

  methods: {
    async refresh() {
      try{
        if(this.key == null) {
          return
        }

        const {data} = await this.axios.get('/api/estimates/' + this.key)

        this.dailyStore = data.dailyStore
        this.weather = data.weather
        this.resultSum = data.resultCustomerSum
        this.error = isEmpty(data.problems)
          ? null
          : ['次の理由で客数予測が行えません：', ...data.problems]

        this.$emit('change', {estimates: data.estimates || [], estimateSum: data.estimateCustomerSum})
      }
      catch(e) {this.$handler(e)}
    },

    // 参考日の変更
    async onChangeReferenceDate(value) {
      try {
        if(this.dailyStore != null) {
          await this.axios.put('/api/daily_stores/' + this.dailyStore.id, {reference_date: value})
          await this.refresh()
          // this.$emit('refresh')
        }
      }
      catch(e) {this.$handler(e)}
    },

    // makeEstimates(date, cols, data) {
    //   this.dailyStore = data.dailyStore
    //   this.weather = data.weather

    //   //
    //   const warnings = []

    //   if(isEmpty(data.results)) {
    //     const referenceDate = dateToObject(data.dailyStore.reference_date)
    //     if(isValid(referenceDate)) {
    //       warnings.push(dateFilter(referenceDate, 'yyyy年M月d日') + 'の実績客数データがありません')
    //     }
    //     else {
    //       warnings.push('参考日が設定されていません')
    //     }
    //   }

    //   if(isEmpty(data.estimate)) {
    //     warnings.push(dateFilter(date, 'yyyy年M月d日') + 'の予測客数データがありません')
    //   }

    //   if(warnings.length !== 0) {
    //     this.icon = {
    //       name: 'warning',
    //       color: 'warning',
    //       texts: [
    //         '次の理由で客数予測が行えません：',
    //         ...warnings,
    //       ],
    //     }
    //     return cols.map(() => Number.MAX_SAFE_INTEGER)
    //   }


    //   //
    //   const resultSum = Object.values(data.results).reduce((a, v) => a + (v.customers || 0), 0)
    //   if(!resultSum) {
    //     return cols.map(() => 0)
    //   }

    //   this.icon = {
    //     name: 'info',
    //     color: 'primary',
    //     texts: [
    //       dateFilter(data.dailyStore.reference_date, 'yyyy年M月d日') + 'の実績客数：' + resultSum,
    //       dateFilter(date, 'yyyy年M月d日') + 'の予測客数：' + data.estimate.customers,
    //     ],
    //   }

    //   const estimate = data.estimate.customers || 0

    //   return cols.map(col =>
    //     Math.ceil(get(data, ['results', col, 'customers'], 0) * estimate / resultSum)
    //   )
    // },

    // REボタン
    reEdit() {
      this.$refs.shifts_estimates_re.show(this.dailyStore)
    },

    async reConfirm(data) {
      try {
        await this.axios.put('/api/daily_stores/' + this.dailyStore.id, data)

        this.refresh() // TODO: DailyStoreのみ、もっと簡素な流れがあるはず
          .catch(() => {console.warn('refresh reject in ShiftsEstimates reConfirm')})

        this.$emit('refresh') // TODO: DailyStoreのみ、もっと簡素な流れがあるはず
        this.$refs.shifts_estimates_re.hide()
      }
      catch(e) {this.$handler(e)}
    },

  },
}
</script>
